
import { Component, Prop, toNative, Vue } from 'vue-facing-decorator';
import { ProgramTagItem } from '@/entities/Program/ProgramTagItem';
import ProgramTagItemEditPane from '@/components/Program/ProgramDetail/Tags/ProgramTagItemEditPane.vue';
import ProgramTagListViewEditItemPane from '@/components/Program/ProgramDetail/Tags/ProgramTagListViewEditItemPane.vue';
import { Root } from '@/main';
@Component({
  components: {
    ProgramTagItemEditPane,
    ProgramTagListViewEditItemPane,
  },
})
class ProgramTagListView extends Vue {
  public loaderBorderColor = '';
  @Prop() private tagItems?: ProgramTagItem[];
  @Prop() private applicationborderColor?: string;
  private localTagItem: ProgramTagItem | null = null;
  private createNewTag = false;
  private ClosePreviouslyOpenTagsForEdit() {
    Root.emit('program-tag-close-others-operation');
  }
  private AddTag() {
    this.ClosePreviouslyOpenTagsForEdit();
    const newItem = ProgramTagItem.createEmpty();
    this.localTagItem = newItem;
    this.RedirectToItem(this.tagItems!.length);
    this.createNewTag = true;
  }
  private CloseTag() {
    this.localTagItem = null;
    this.$emit('program-tag-close-operation', true);
    Root.emit('clearCheckboxes', []);
    this.createNewTag = false;
  }
  private programTagItemCancelOperation() {
    this.localTagItem = null;
    this.createNewTag = false;
  }
  private mounted() {
    if (this.applicationborderColor != null) {
      this.loaderBorderColor = this.applicationborderColor;
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    Root.on('program-tag-item-edit-operation', (pt: ProgramTagItem) => {
      this.programTagItemCancelOperation();
    });
    Root.on('program-tag-close-others-operation', () => {
      this.localTagItem = null;
    });
  }
  private RedirectToItem(index: number) {
    setTimeout(() => {
      const element = document.querySelectorAll('[indexTag="' + index + '"]')[0];
      if (element) {
        element.scrollIntoView({
          block: 'end',
          behavior: 'smooth',
          inline: 'end',
        });
      }
    }, 100);
  }
}
export default toNative(ProgramTagListView);
